export enum StudentType  {
  LOGIN = "STUDENT_LOGIN",
  LOGOUT = "STUDENT_LOGOUT",
  REGISTER = "STUDENT_REGISTER",
  AUTH_ERROR = "STUDENT_AUTH_ERROR",
  LOADING = "STUDENT_LOADING",
  GET_COURSES = "STUDENT_GET_COURSES",
  REGISTER_COURSES = "STUDENT_REGISTER_COURSES",
  REGISTERED_COURSES = "STUDENT_REGISTERED_COURSES",
  GET_LESSONS = "STUDENT_GET_LESSONS",
  GET_NOTES = "STUDENT_GET_NOTES",
  GET_ASSIGNMENTS = "STUDENT_GET_ASSIGNMENTS",
  UNREGISTER_COURSES = "STUDENT_UNREGISTER_COURSES",
  SUBMIT_ASSIGNMENT = "STUDENT_SUBMIT_ASSIGNMENT",
  GET_SUBMITTED_ASSIGNMENTS = "STUDENT_GET_SUBMITTED_ASSIGNMENTS"
}

export enum TeacherType {
  LOGIN = "TEACHER_LOGIN",
  LOGOUT = "TEACHER_LOGOUT",
  REGISTER = "TEACHER_REGISTER",
  AUTH_ERROR = "TEACHER_AUTH_ERROR",
  LOADING = "TEACHER_LOADING",
  GET_COURSES = "TEACHER_GET_COURSES",
  CREATE_COURSES = "TEACHER_CREATE_COURSES",
  GET_LESSONS = "TEACHER_GET_LESSONS",
  GET_ASSIGNMENTS = "TEACHER_GET_ASSIGNMENTS",
  GET_NOTES = "TEACHER_GET_NOTES",
  GET_SUBMITTED_ASSIGNMENTS = "TEACHER_GET_SUBMITTED_ASSIGNMENTS",
  GRADE_ASSIGNMENT = "TEACHER_GRADE_ASSIGNMENT"
}

export enum AdminType {
  LOGIN = "ADMIN_LOGIN",
  LOGOUT = "ADMIN_LOGOUT",
  GET_ACCOUNTS = "ADMIN_GET_ACCOUNTS",
  AUTH_ERROR = "ADMIN_AUTH_ERROR",
  LOADING = "ADMIN_LOADING",
  TERMINATE_ACCOUNT = "TERMINATE_ACCOUNT"
}